'use client';

import { useContext } from 'react';

import { AppEnvContext, type RegionType, type ThemeType } from '@/context/AppEnv';

export function useAppEnv() {
  const ctx = useContext(AppEnvContext);

  if (!ctx) throw new Error('useAppEnv must be used within <AppEnvProvider>');

  return ctx;
}

export function useRegion(): { region: RegionType; setRegion: (r: RegionType) => void } {
  const { region, setRegion } = useAppEnv();

  return { region, setRegion };
}

export function useTheme(): {
  theme: ThemeType;
  setTheme: (t: ThemeType) => void;
  toggleTheme: () => void;
} {
  const { theme, setTheme, toggleTheme } = useAppEnv();

  return { theme, setTheme, toggleTheme };
}
